import { $ } from "venuescanner-js/tools/elemental";
const maxDocumentSize = (useHeight = true) => {
  if (typeof window === "undefined") return 0;
  try {
    const body = document.body;
    const html = document.documentElement;

    const height = useHeight
      ? Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        )
      : Math.max(
          body.scrollWidth,
          body.offsetWidth,
          html.clientWidth,
          html.scrollWidth,
          html.offsetWidth
        );
    return height;
  } catch (e) {
    return 0;
  }
};
const supportPageOffset =
  typeof window !== "undefined" && window.pageXOffset !== undefined;
const isCSS1Compat =
  typeof document !== "undefined" &&
  (document.compatMode || "") === "CSS1Compat";

const windowScrollPos = () => {
  if (typeof window === "undefined") return 0;
  let x = supportPageOffset
    ? window.pageXOffset
    : isCSS1Compat
    ? document.documentElement.scrollLeft
    : document.body.scrollLeft;
  let y = supportPageOffset
    ? window.pageYOffset
    : isCSS1Compat
    ? document.documentElement.scrollTop
    : document.body.scrollTop;
  return [x, y];
};
const animateScroll = (
  element,
  { vertical = true, to, time = 500, interval = 20 }
) => {
  if (typeof window === "undefined") return;
  if (typeof element === "string") element = document.querySelector(element);
  if (!element) element = window;
  const attr = vertical
    ? element.scrollY
      ? "scrollY"
      : "scrollTop"
    : element.scrollX
    ? "scrollX"
    : "scrollLeft";
  const windowScroll = element === window ? windowScrollPos() : [0, 0];
  const current =
    element === window ? windowScroll[vertical ? 1 : 0] : element[attr];
  const dx = to - current;
  const da = (Math.PI / 2) * (interval / time);
  let a = 0;
  const setScroll = () => {
    a += da;
    const newScroll = current + dx * Math.sin(a);
    if (element === window) {
      windowScroll[vertical ? 1 : 0] = newScroll;
      element.scrollTo(...windowScroll);
    } else {
      element[attr] = Math.round(newScroll);
    }
    if (a < Math.PI / 2) setTimeout(setScroll, interval);
  };
  setScroll();
};
const scrollToElement = (
  element,
  { parent, vertical = true } = { parent: null, vertical: true }
) => {
  if (typeof window === "undefined" || !document) return;
  if (typeof element === "string") element = $(element).get(0);
  if (!parent) parent = window;
  if (!element) return;
  const top = vertical
    ? element.getBoundingClientRect().top
    : element.getBoundingClientRect().left;
  const offset =
    parent === window
      ? 0
      : vertical
      ? parent.getBoundingClientRect().top
      : parent.getBoundingClientRect().left;
  const scrollTop =
    parent === window
      ? windowScrollPos()[vertical ? 1 : 0]
      : vertical
      ? parent.scrollY || parent.scrollTop
      : parent.scrollX || parent.scrollLeft;
  const maxScroll =
    parent === window
      ? maxDocumentSize(vertical) -
        window[vertical ? "innerHeight" : "innerWidth"]
      : vertical
      ? parent.scrollHeight - parent.clientHeight
      : parent.scrollWidth - parent.clientWidth;
  let to = top + scrollTop - offset - 10;
  if (to > maxScroll) to = maxScroll;
  animateScroll(parent, { to, vertical });
};
if (typeof window !== "undefined") window.animateScroll = animateScroll;
export { animateScroll, scrollToElement };
